import { Container, Row } from "reactstrap";
import { Avatars, UIKits } from "../../../constants";
import AvatarSizes from "./AvatarSizes";
import Grouping from "./Grouping";
import Ratio from "./Ratio";
import Shapes from "./Shapes";
import StatusIndicator from "./StatusIndicator";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const AvatarsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Avatars} parent={UIKits} />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <AvatarSizes />
            <StatusIndicator />
            <Shapes />
            <Ratio />
            <Grouping />
          </Row>
        </div>
      </Container>
    </>
  );
};
export default AvatarsContainer;
